import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { compose } from 'react-apollo';
import GraphQLClient from '@api/graphql/GraphQLClient';
import * as Mutations from '@api/graphql/mutations';
import { createProductAttributeVariables, ProductAttributeType } from '@api/graphql/types';
import { Paths } from '..';
import Form from '@components/Form/Form';

type Props = {
} & InjectedIntlProps & RouteComponentProps;


interface State {
    formData: createProductAttributeVariables;
}

class ProductAttributeCreate extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            formData: {
                name: '',
                code: '',
                filterable: true,
                is_active: true,
                type: ProductAttributeType.SIMPLE,
            },
        };
    }

    public onSubmit = (variables: createProductAttributeVariables) => {
        return GraphQLClient.mutate({
            mutation: Mutations.createProductAttribute, variables,
        });
    }

    private validate(variables: createProductAttributeVariables): boolean {
        return !!variables.code && !!variables.name && !!variables.type;
    }

    public render() {
        const fields = [
            {name: 'name', type: 'text', props: {required: true}},
            {name: 'code', type: 'text', props: {required: true}},
            {name: 'filterable', type: 'checkbox', props: {required: true}},
            {name: 'is_active', type: 'checkbox', props: {required: true}},
            {name: 'type', type: 'productattributetype', props: {required: true}},
        ];

        return (
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        <div className="ibox-content">
                            <Form
                                fields={[{id: 'default', fields}]}
                                validate={this.validate}
                                intlPrefix={'module.productAttribute'}
                                redirectPath={Paths.productAttribute}
                                formData={this.state.formData}
                                onChange={(formData: createProductAttributeVariables) => {
                                    this.setState({formData});
                                }}
                                onSubmit={this.onSubmit}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default compose(
    injectIntl,
    withRouter,
)(ProductAttributeCreate);



// WEBPACK FOOTER //
// ./src/modules/ProductAttribute/pages/ProductAttributeCreate.tsx